import { gql } from '@apollo/client';
import { bookmarksFragment } from '../fragments/bookmarks';
import { graphql } from '../../graphql';

export const getBookmarkIds = graphql(`
  query BookmarkIds {
    bookmarks {
      __typename
      item {
        __typename
        id
      }
    }
  }
`);

export const getAllBookmarks = gql`
  query BookmarksAll {
    bookmarks {
      item {
        ...bookmarksItemFields
      }
    }
  }
  ${bookmarksFragment}
`;
